module.exports = __webpack_public_path__ + "img/SKMJ_safeprocess.fa598fa3.png";